module.exports = __webpack_public_path__ + "static/media/icon_close_blue.b84d370a.svg";